import i18n from '../../language/index'
const moduleAnimationList = [{
  id: 0,
  typeTitle: i18n.t('components_my_animation_banner_animation_list_2241'),
}, {
  id: 1,
  typeTitle: i18n.t('components_my_animation_banner_animation_list_2242'),
}, {
  id: 2,
  typeTitle: i18n.t('components_my_animation_banner_animation_list_2243'),
}, {
  id: 3,
  typeTitle: i18n.t('components_my_animation_banner_animation_list_2244'),
}, {
  id: 4,
  typeTitle: i18n.t('components_my_animation_banner_animation_list_2245'),
}, {
  id: 5,
  typeTitle: i18n.t('components_my_animation_banner_animation_list_2246'),
}, {
  id: 6,
  typeTitle: i18n.t('components_my_animation_banner_animation_list_2247'),
}, {
  id: 7,
  typeTitle: i18n.t('components_my_animation_banner_animation_list_2248'),
}]

export default moduleAnimationList



// WEBPACK FOOTER //
// ./src/components/my_animation/banner_animation_list.js